import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import { artifactOptions, judgmentOptions, type OutputOption } from '../../store/outputs';
import { useBuilder } from '../../store/provider';
import { useOutputsSuggestions } from '../../store/suggestions';
import type { Suggestion } from '../../store/types';
import InlineEditPair from './primitives/inline-edit-pair';
import PatchCard from './primitives/patch-card';
const OutputsSuggestions = () => {
  const $ = _c(4);
  const suggestions = useOutputsSuggestions();
  if (suggestions.length === 0) {
    return null;
  }
  let t0;
  if ($[0] !== suggestions) {
    t0 = suggestions.map(_temp);
    $[0] = suggestions;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <div className="flex flex-col gap-3">{t0}</div>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};
const OutputsPatchCard = t0 => {
  const $ = _c(44);
  const {
    suggestion
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "agentBuilder.canvas.suggestion.outputs"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("agents", t1);
  const {
    state
  } = useBuilder();
  const op = suggestion.operation;
  if (op.kind !== "update_outputs") {
    return null;
  }
  let T0;
  let T1;
  let t10;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[1] !== op.outputs.artifactKey || $[2] !== op.outputs.judgmentKey || $[3] !== state.bundle || $[4] !== suggestion.canApply || $[5] !== suggestion.id || $[6] !== t) {
    const current = state.bundle.outputs ?? {};
    let t11;
    if ($[18] !== t) {
      t11 = (key, options) => {
        if (!key) {
          return t(_temp2);
        }
        return options.find(option => option.value === key)?.label ?? key;
      };
      $[18] = t;
      $[19] = t11;
    } else {
      t11 = $[19];
    }
    const describe = t11;
    const judgments = judgmentOptions(state.bundle);
    const artifacts = artifactOptions(state.bundle);
    T1 = PatchCard;
    t7 = suggestion.id;
    if ($[20] !== t) {
      t8 = t(_temp3);
      $[20] = t;
      $[21] = t8;
    } else {
      t8 = $[21];
    }
    t9 = !suggestion.canApply;
    if ($[22] !== t) {
      t10 = t(_temp4);
      $[22] = t;
      $[23] = t10;
    } else {
      t10 = $[23];
    }
    t5 = "flex flex-col gap-1";
    let t12;
    if ($[24] !== t) {
      t12 = t(_temp5);
      $[24] = t;
      $[25] = t12;
    } else {
      t12 = $[25];
    }
    t6 = <InlineEditPair label={t12} current={describe(current.judgmentKey, judgments)} suggested={describe(op.outputs.judgmentKey, judgments)} />;
    T0 = InlineEditPair;
    if ($[26] !== t) {
      t2 = t(_temp6);
      $[26] = t;
      $[27] = t2;
    } else {
      t2 = $[27];
    }
    t3 = describe(current.artifactKey, artifacts);
    t4 = describe(op.outputs.artifactKey, artifacts);
    $[1] = op.outputs.artifactKey;
    $[2] = op.outputs.judgmentKey;
    $[3] = state.bundle;
    $[4] = suggestion.canApply;
    $[5] = suggestion.id;
    $[6] = t;
    $[7] = T0;
    $[8] = T1;
    $[9] = t10;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
  } else {
    T0 = $[7];
    T1 = $[8];
    t10 = $[9];
    t2 = $[10];
    t3 = $[11];
    t4 = $[12];
    t5 = $[13];
    t6 = $[14];
    t7 = $[15];
    t8 = $[16];
    t9 = $[17];
  }
  let t11;
  if ($[28] !== T0 || $[29] !== t2 || $[30] !== t3 || $[31] !== t4) {
    t11 = <T0 label={t2} current={t3} suggested={t4} />;
    $[28] = T0;
    $[29] = t2;
    $[30] = t3;
    $[31] = t4;
    $[32] = t11;
  } else {
    t11 = $[32];
  }
  let t12;
  if ($[33] !== t11 || $[34] !== t5 || $[35] !== t6) {
    t12 = <div className={t5}>{t6}{t11}</div>;
    $[33] = t11;
    $[34] = t5;
    $[35] = t6;
    $[36] = t12;
  } else {
    t12 = $[36];
  }
  let t13;
  if ($[37] !== T1 || $[38] !== t10 || $[39] !== t12 || $[40] !== t7 || $[41] !== t8 || $[42] !== t9) {
    t13 = <T1 suggestionId={t7} note={t8} isStale={t9} title={t10}>{t12}</T1>;
    $[37] = T1;
    $[38] = t10;
    $[39] = t12;
    $[40] = t7;
    $[41] = t8;
    $[42] = t9;
    $[43] = t13;
  } else {
    t13 = $[43];
  }
  return t13;
};
export default OutputsSuggestions;
function _temp(s) {
  return <OutputsPatchCard key={s.id} suggestion={s} />;
}
function _temp2($) {
  return $.unset;
}
function _temp3($_0) {
  return $_0.refined;
}
function _temp4($_1) {
  return $_1.title;
}
function _temp5($_2) {
  return $_2.judgment;
}
function _temp6($_3) {
  return $_3.artifact;
}